// externals

// libraries
import { capitalize, isValidNumber } from '@makemydeal/dr-common-utils';
import type { DealHistory, StateTree } from '@makemydeal/dr-dash-types';
import * as dealEffectiveSelectors from '@makemydeal/dr-dash-store/selectors/dealEffectiveSelectors';

// consts/enums
import { NOT_AVAILABLE } from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const TermLength = ({ deal, hasDelta = false }: { deal?: DealHistory; hasDelta?: boolean }) => {
    const offerType = useTrackedSelector((state: StateTree) => dealEffectiveSelectors.selectEffectiveOfferType(state, deal), {
        component: 'TermLength',
        field: 'effectiveOfferType',
        emitValue: true
    });
    const termMonths = useTrackedSelector(
        (state: StateTree) => dealEffectiveSelectors.getEffectiveSelectedTermMonths(state, deal),
        { component: 'TermLength', field: 'effectiveSelectedTermMonths' }
    );

    const value = termMonths != null && isValidNumber(termMonths) ? `${termMonths} Months` : NOT_AVAILABLE;
    const label = `${capitalize(offerType)} Term`;

    return <DealSummaryItem label={label} value={value} hasDelta={hasDelta} />;
};

export default TermLength;
